
import { CellVertex } from './CellVertex';
/**
 * Represents vertex which keeps static cell value
 */
export class ValueCellVertex extends CellVertex {
    /** Static cell value. */
    constructor(parsedValue, rawValue) {
        super();
        this.parsedValue = parsedValue;
        this.rawValue = rawValue;
    }
    getValues() {
        return { parsedValue: this.parsedValue, rawValue: this.rawValue };
    }
    setValues(values) {
        this.parsedValue = values.parsedValue;
        this.rawValue = values.rawValue;
    }
    /**
     * Returns cell value stored in vertex
     */
    getCellValue() {
        return this.parsedValue;
    }
}
